import type { Route } from '@angular/router';
import { offerCategoryRoutes } from './category/offer-category.routes';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';
import { CategoryFormServiceToken } from '../../common/category-details/abstract-category-form-service.token';
import { OfferCategoryFormService } from './service/offer-category-form.service';

export const offerRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/offer-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'category',
    children: offerCategoryRoutes,
    title: 'PAGES.OFFER.CATEGORY.BREADCRUMB.LIST',
    providers: [{ provide: CategoryFormServiceToken, useClass: OfferCategoryFormService }],
  },
  {
    path: 'new',
    loadComponent: () => import('./details/offer-details.component'),
    title: 'PAGES.OFFER.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('./details/offer-details.component'),
    title: 'PAGES.OFFER.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
];
